import { defineStore } from "pinia";
import { getGameProvider } from "@/api/dataNoByDataTypeNo";

export const useCommonStore = defineStore("common", {
  state: () => ({
    gameProvider: [], // 保存币种列表
    cacheTimestamps: {
      gameProvider: null,
    },
  }),
  actions: {
    async fetchGameProvider() {
      await this.fetchDataWithCache(
        "gameProvider",
        "gameProviderCache",
        "gameProviderCacheTimestamp",
        getGameProvider
      );
    },
    async fetchDataWithCache(stateKey, cacheKey, timestampKey, apiMethod) {
      try {
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));
        const cachedTimestamp = localStorage.getItem(timestampKey);

        const now = Date.now();
        const oneHour = 60 * 60 * 1000;

        if (cachedData && cachedTimestamp && now - cachedTimestamp < oneHour) {
          this[stateKey] = cachedData;
          console.log(`使用缓存的 ${stateKey} 数据`);
        } else {
          console.log(`缓存过期或不存在，重新请求 ${stateKey} 数据`);
          const response = await apiMethod();
          if (response.code === 200) {
            this[stateKey] = response.data || [];
            // 更新缓存
            localStorage.setItem(cacheKey, JSON.stringify(this[stateKey]));
            localStorage.setItem(timestampKey, JSON.stringify(now));
          } else {
            console.error(`获取${stateKey}列表失败:`, response.message);
          }
        }
      } catch (error) {
        console.error(`请求${stateKey}列表失败:`, error);
      }
    },
  },
});
